
import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Code,
    name: 'StageItemsMergeSchema',
})
export class StageItemMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name?: string;

    @MergeField()
    source?: string;

    @MergeField()
    buyPrice?: number = 0

    @MergeField()
    sellPrice?: number = 0

    @MergeField()
    customBuyPrice?: boolean;

    @MergeField()
    customSellPrice?: boolean;

    @MergeField()
    status?: string;

    @MergeField()
    invoicingStatus: string;

    @MergeField()
    location?: string;

    @MergeField()
    note?: string;

    @MergeField()
    codeUoM?: string;

    @MergeField()
    baseQuantity?: number;

    @MergeField()
    suppliedBySubcontractor?: boolean;

    @MergeField()
    upc?: string;

    @MergeField()
    description: string;

    @MergeField()
    longDescription?: string;

    @MergeField()
    quantity?: number;

    @MergeField({
        displayName: 'Sub Total Buy'
    })
    subTotalBuy: string;

    @MergeField({
        displayName: 'Sub Total Sell'
    })
    subTotalSell: string;

    @MergeField()
    sellTax?: string;

    @MergeField()
    totalSellIncTax?: string;

    @MergeField()
    completed?: boolean;

    @MergeField()
    itemTaskCompleted?: boolean;

    @MergeField()
    comply?: string;

    rawValues?: any
}

export const StageItemsMergeSchema = getSchema(StageItemMergeData);

